import React, { useEffect } from "react";
import "./styles.scss";
import "./mobile.scss";
import { NewsCard, NewsGroup, TrendingNewsCard } from "../../../components";
import { useHistory, withRouter } from "react-router-dom";
// import { getNewsByCategoryPage } from "../../news/service/news.service";
// import { getCategoryById } from "../../CreateNewItem/CreateNewCategory/service/category.service";
import { getLanguage } from "../../../utils/environment";
import { getSuggestionsNews } from "../../news/service/news.service";
import { getInsight } from "../../../utils";
import {
  ConsoleTopLeftAdd,
  HomePageCenterAdd,
  NewsViewLeftAdd,
} from "../advertiesments";
import { transformPropOrder } from "framer-motion";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const categoryId = process.env.REACT_APP_CABINET_NEWS;
const pageCount = process.env.REACT_APP_P_COUNT;
const lan = getLanguage();

const Index = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [news, setNews] = React.useState([]);
  const [menu, setMenu] = React.useState("");

  const { news_id } = props;

  const history = useHistory();
  const location = useLocation();
  const noOfNews = "5";

  useEffect(() => {
    const fetchPageData = async () => {
      setIsLoading(true); // Start loading

      try {
        const insight = await getInsight();
        // console.log("Insight found:", insight);

        if (insight?.insight_id) {
          const response = await getSuggestionsNews(
            lan,
            insight.insight_id,
            news_id,
            noOfNews
          );
          // console.log("Response from getSuggestionsNews:", response);

          if (response?.data?.news) {
            // console.log("news:::", response.data.news);
            setNews(response.data.news);
          } else {
            setNews([]);
          }
        }
      } catch (error) {
        console.error("Error fetching page data:", error);
      } finally {
        setIsLoading(false); // Stop loading
      }
    };

    if (news_id) {
      fetchPageData();
    }
  }, [news_id]);

  return (
    <>
      <NewsGroup
        data={{
          titleName: "You may also like",
          type: "en",
          linkName: "",
        }}
        // onClickViewNews={() => {
        //   props.history.push("/" + categoryId);
        //   props.setMenuName(categoryId);
        // }}
      >
        {/* {newsList?.length > 0 && (
          <>
            {newsList
              .filter((item) => item.news_id !== news_id)
              .map((item, index) => {
                // Check if the item has updates
                const hasUpdates =
                  Array.isArray(item.updates) && item.updates.length > 0;

                // If updates exist, use the latest update (or modify as needed)
                const displayItem = hasUpdates
                  ? {
                      ...item,
                      ...item.updates[item.updates.length - 1],
                    }
                  : item;

                return (
                  <React.Fragment key={index}>
                    <TrendingNewsCard
                      data={{
                        isBorder: true,
                        isTrendingNo: false,
                        trendingNo: "",
                        img_url: displayItem?.images?.[0]?.url,
                        created_at: displayItem?.created_at,
                        header: displayItem?.title[lan],
                        content: displayItem?.content,
                      }}
                      onClick={() => {
                        
                        
                       const generatedSlug = displayItem?.title?.[lan]
                         ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                          ?.trim()
                         .split(/\s+/)
                         .slice(0, 5)
                         .join("-")
                         .replace(/-+/g, "-");
                       history.push(
                         `/${generatedSlug}/${displayItem?.news_id}`
                       );;
                      }}
                    />
                    {/*<NewsCard*/}
        {/*    key={index}*/}
        {/*    data={{*/}
        {/*        type: "small",*/}
        {/*        isBorder: true,*/}
        {/*        isUpdate: hasUpdates,*/}
        {/*    }}*/}
        {/*    item={displayItem}*/}
        {/*    onClick={() => {*/}
        {/*        */}
        {/*        history.push(`/${item?.news_id}/news`);*/}
        {/*    }}*/}
        {/*/>*/}
        {/* </React.Fragment> */}
        {/* );
              })}
          </>
        )} */}
        {Array.isArray(news) && news.length > 0 ? (
          (props.type === "small" ? news.slice(0, 3) : news).map(
            (news, index) => (
              <>
                {props.type !== "small" && (
                  <TrendingNewsCard
                    data={{
                      isBorder: true,
                      isTrendingNo: false,
                      trendingNo: false,
                      isDate: false,
                      img_url: news?.images?.[0]?.url,
                      header: news?.title[lan],
                      content: news?.content,
                      created_at: news?.created_at,
                      tagViews: news?.views,
                    }}
                    onClick={() => {
                      const generatedSlug = news?.title?.[lan]
                        ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                        ?.replace(/\//g, "")
                        ?.replace(/\s*-\s*/g, " ")
                        ?.trim()
                        .split(/\s+/)
                        .slice(0, 5)
                        .join("-")
                        .replace(/-+/g, "-");
                      props.history.push(`/${generatedSlug}/${news?.news_id}`);
                    }}
                    // onClick={() => {}}
                  />
                )}

                {props.type === "small" && (
                  <>
                    {/* {console.log("small news::", news)} */}
                    <NewsCard
                      data={{ type: "small", isBorder: true }}
                      item={news}
                      onClick={() => {
                        const generatedSlug = news?.title?.[lan]
                          ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                          ?.replace(/\//g, "")
                          ?.replace(/\s*-\s*/g, " ")
                          ?.trim()
                          .split(/\s+/)
                          .slice(0, 5)
                          .join("-")
                          .replace(/-+/g, "-");
                        props.history.push(
                          `/${generatedSlug}/${news?.news_id}`
                        );
                      }}
                    />
                  </>
                )}

                {index === 2 && props.type !== "small" && (
                  <>
                    <div className={"bottom-ad mt-2 mb-2"}>
                      {/* <ConsoleTopLeftAdd /> */}

                      <NewsViewLeftAdd />
                    </div>
                    <div className="bottom-ad-mobile">
                      <HomePageCenterAdd />
                    </div>
                  </>
                )}
              </>
            )
          )
        ) : (
          <div className="d-flex justify-content-center align-items-center">
            <h6 className="text-muted">No Suggestions News Available</h6>
          </div>
        )}

        {/* {news.index === 1 && <ConsoleTopLeftAdd />} */}
      </NewsGroup>
    </>
  );
};
export default withRouter(Index);
// export default Index;
